import React, {useState} from "react";
import axios from 'axios';
import { Action, Store } from "@byhuz/huz-ui-state";
import ModalBox from "components/Alert/Modal.js";
import Spinner from "components/Alert/Spinner";
import useAuth from "components/Common/UseAuth";
import Paypal from "components/Common/Paypal";

// components
export default function AntiTheftCode() {
    const {checkSession,user}=useAuth();

    const [modalDetail, setModalDetail] = useState("");  
    const showModal = (title,desc) => {
      setModalDetail(<ModalBox title={title} desc={desc} show="true" callback={()=>{
          setModalDetail(<div></div>);   
          setLoading(false);       
      }}/>);
    }
        
    const countRef = React.useRef(0);
    const intervalIDRef = React.useRef(null);
    const [loading, setLoading] = useState(false);
    const [ serialnumber, setSerialNumber ] = React.useState("");    
    const [ antitheftcode, setAntitheftcode ] = React.useState("");
    const [ vinNumber, setvinNumber ] = React.useState("");
    const [ history, setHistory ] = React.useState("");

  
  // Generation Function

  const getCodeFromServer = () => {
    const antitheftData = {
      serial: serialnumber.toLocaleUpperCase(),
      sku: "antitheftcode"
    }

    axios.post('generatetheftcode',antitheftData)
    .then(res=>{

      if (parseInt(res.data.code)===404) {       
        showModal("AntiTheft Code",
            <>     
            <span>AntiTheft Code Not Generated!</span>   
            </>  
        );
        setLoading(false);
        clearInterval(intervalIDRef.current);
        intervalIDRef.current = null;
        return;
      }

      if (parseInt(res.data.code)===400) {       
        showModal("AntiTheft Code",
            <>     
            <span>Not Enough Credit, Please buy credits!</span>   
            </>  
        );
        setLoading(false);
        clearInterval(intervalIDRef.current);
        intervalIDRef.current = null;
        return;
      }

      if (parseInt(res.data.code)===200 && res.data.payload.result.state===3 && res.data.payload.result.found===1) { 
        if (res.data.payload.result.antiTheft===null) {
          setHistory("Probably this head unit not requries pin code to unlock");
        } else {
          setHistory(res.data.payload.result.history===1?"This head unit taken from this car, and changed it with new one":"Seems that this head unit is still in this car");
        }            
        setAntitheftcode(res.data.payload.result.antiTheft);
        setvinNumber(res.data.payload.result.vinNumber);
        setLoading(false);
        clearInterval(intervalIDRef.current);
        intervalIDRef.current = null;
        checkSession();
      }

      if (parseInt(res.data.code)===200 && res.data.payload.result.state===3 && res.data.payload.result.found===0) {                     
        setAntitheftcode(res.data.payload.result.antiTheft);
        setHistory("Not Found!");
        setvinNumber("Not Found!");
        setLoading(false);
        clearInterval(intervalIDRef.current);
        intervalIDRef.current = null;
        checkSession();
      }

      if (parseInt(res.data.code)===200 && res.data.payload.result.state===1 && res.data.payload.result.found===2) {                     
        setAntitheftcode(res.data.payload.result.antiTheft);
        setHistory("Not Generated!");
        setvinNumber("Not Generated!");
        setLoading(false);
        clearInterval(intervalIDRef.current);
        intervalIDRef.current = null;
        checkSession();
        showModal("AntiTheft Code",
            <>     
            <span>Try Again!</span>   
            </>  
        );
      }

      if (parseInt(res.data.code)===200 && res.data.payload.result.state===3 && res.data.payload.result.found===3) {                     
        setAntitheftcode(res.data.payload.result.antiTheft);
        setHistory("Not Generated!");
        setvinNumber("Not Generated!");
        setLoading(false);
        clearInterval(intervalIDRef.current);
        intervalIDRef.current = null;
        checkSession();
        showModal("AntiTheft Code",
            <>     
            <span>Incorrect Serial!</span>   
            </>  
        );
      }

      if (parseInt(res.data.code)===300 || parseInt(res.data.code)===301) {      
        setAntitheftcode("");
        setHistory("Processing, please wait...")
        setvinNumber("Trying to find...");        
      }

    })
    .catch(err=>{
      console.log(err);
      Store.dispatch(Action.update("loggedIn", false));
      Store.dispatch(Action.update("user"));
      return;
    });      

    if (countRef.current>=30) {
      countRef.current = 0;
      setLoading(false);
      clearInterval(intervalIDRef.current);
      intervalIDRef.current = null;
      showModal("AntiTheft Code",
        <>     
        <span>AntiTheft Code Not Generated!, Try Again</span>   
        </>  
      );      
    }
        
    countRef.current++;         
  }

  const handleSubmitAntiTheftCode = (e) => {
    e.preventDefault();

    if (serialnumber==="" || serialnumber==="" || serialnumber.length!==14) {
        showModal("AntiTheft Code",
            <>     
            <span>Check Serial Number</span>   
            </>  
        );
        return;
    }

    setAntitheftcode("");
    setHistory("")
    setvinNumber("");        
    
    setLoading(true);

    intervalIDRef.current = setInterval(getCodeFromServer,3000);    
    getCodeFromServer();
  }

  const PaymentSuccess = () => {    
    setLoading(false);
    checkSession();
    showModal("MBLink Payment Method",
        <>     
          <span>Thank you for purchasing...</span>   
        </>  
    );
  }

  const PaymentError = (err) => {
    setLoading(false);
    showModal("MBLink Payment Method",
        <>     
          <span>Payment could not be received. Please try again!</span>   
        </>  
    );
  }

  const PaymentStart = () => {
    setLoading(true);
  }  

  const doPayment = (price,sku) => {
    showModal("MBLink Payment Method",
        <>     
          <Paypal sku={sku} onSuccess={PaymentSuccess} onError={PaymentError} onStartTransaction={PaymentStart}></Paypal>   
        </>  
    );
  }

  const getPrice = (sku) => {
    let price = 0;
    user.availabletokens.forEach(skutypes => {
        if (skutypes.sku===sku) {  
          price=skutypes.price;
          return;          
        }
    });
    return price;
  }

  React.useEffect(()=>{    
  },[]);

  return (
    <>
    {loading?<Spinner show={loading} />:null}
    {modalDetail!==""?modalDetail:null}
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">

            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-gray-800 text-xl font-bold">ANTI THEFT CODE</h6>
                        <button className="mx-auto text-white-500 border border-solid border-blue-500 hover:bg-blue-500 hover:text-white active:bg-blue-600 font-bold uppercase text-sm px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" 
                          type="button"
                          onClick={(e)=>doPayment(getPrice("antitheftcode"),"antitheftcode")}
                          >
                            BUY {getPrice("antitheftcode")} EUR 
                        </button>
                    </div>
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form>
                    <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">              
                    </h6>
                    <div className="flex flex-wrap">                        

                        <div className="w-full lg:w-6/12 px-4">                           
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    Serial Number (14 chars)
                                </label>
                                <div className="mb-3 pt-0">
                                    <input type="text" 
                                        placeholder="HBM100F1100222" 
                                        onChange={e=> setSerialNumber(e.target.value.toLocaleUpperCase())}                                        
                                        className="uppercase px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-1/3"/>
                                </div>

                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    Your AntiTheft Code
                                </label>
                                <div className="mb-3 pt-0">
                                    <input type="text" disabled defaultValue={antitheftcode} className="px-3 py-3 placeholder-gray-400 text-gray-700 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"/>
                                </div>

                            </div>

                            <div className="relative w-full mb-3">
                                <button
                                className="bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                                type="button" onClick={handleSubmitAntiTheftCode}
                                >
                                Generate Code
                                </button>
                            </div>
                        </div>  
                
                        <div className="w-full lg:w-6/12 px-4">                           
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    Car Information
                                </label>

                                Notice: We cannot guarantee the accuracy of the information. Some of serial numbers starts with <b>BEM023E10073XXX</b>, please type it as <b>HBM023E10073XXX</b>. Don't forget replace first 2 letter <b>BE</b> with <b>HB</b> <br/><br/>Please click Generate Code button if you can't get response from server.<br/><br/>
                                <b>VIN:</b><br/>
                                {vinNumber}<br/><br/>
                                <b>TAKEN:</b><br/>
                                {history}                               

                            </div>
                        </div>  

                    </div>

                    <hr className="mt-6 border-b-1 border-gray-400" />

                </form>
                </div>
            </div>

        </div>
      </div>
    </>
  );
}
